import styled from 'styled-components'

export const $Action = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300] || '#e0e0e0'};
  border-radius: 6px;
  padding: 10px 12px;
  margin-top: 8px;
`

export const $ActionTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`

export const $ActionMeta = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary || '#666'};
  margin-top: 2px;
`

export const $AppLink = styled.span`
  color: ${({ theme }) => theme.colors?.secondary || theme.palette.primary.main};
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
`

export const $ChangeList = styled.ul`
  margin: 6px 0 0;
  padding-left: 18px;
`

export const $ChangeItem = styled.li`
  font-size: 13px;
  word-break: break-word;
  margin-bottom: 2px;
`

export const $Empty = styled.span`
  font-size: 13px;
  font-style: italic;
  color: ${({ theme }) => theme.palette.text.secondary || '#999'};
`
